import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-day-circles',
  templateUrl: './service-day-circles.component.html',
  styleUrls: ['./service-day-circles.component.scss'],
})
export class ServiceDayCirclesComponent {
  @Input() serviceDays: any[];

  // common props
  @Input() isRecurringService: boolean;
  @Input() repeat: 'Weekly' | 'Monthly' | 'Yearly' | null;
  @Input() repeatOn: string | null;
  @Input() repeatByCode:
    | 'Day of the Week'
    | 'Day of the Month'
    | 'Day of the Week and Month'
    | null;

  // Weekly
  @Input() everyWeeklySpecfiedDay: string | null;
  // @Input() everySpecifiedDays: string | null;

  // Month
  @Input() everySpecifiedMonths: string | null;
  @Input() dayOfWeek: string | null;

  // Year
  @Input() dayOfMonth: string | null;
  @Input() monthOfYear: string | null;

  constructor() {}

  getOrdinal(n: number) {
    let ord = 'th';

    if (n % 10 === 1 && n % 100 !== 11) {
      ord = 'st';
    } else if (n % 10 === 2 && n % 100 !== 12) {
      ord = 'nd';
    } else if (n % 10 === 3 && n % 100 !== 13) {
      ord = 'rd';
    }
    return n + ord;
  }

  getRepeatScheduleMsg() {
    if (this.isRecurringService && this.repeat) {
      switch (this.repeat) {
        case 'Weekly': {
          const isPlural: boolean = Number(this.everyWeeklySpecfiedDay) > 1;

          return `Repeat every ${
            isPlural ? this.everyWeeklySpecfiedDay : ''
          } week${isPlural ? 's' : ''} on `;
        }
        case 'Monthly': {
          const isPlural: boolean = Number(this.everySpecifiedMonths) > 1;

          if (this.repeatByCode === 'Day of the Week') {
            return `Repeat every ${this.everySpecifiedMonths} month${
              isPlural ? 's' : ''
            } on ${this.repeatOn ? this.repeatOn : ''} ${
              this.dayOfWeek
            } Of the month`;
          }
          if (this.repeatByCode === 'Day of the Month') {
            return `Repeat every ${this.everySpecifiedMonths} month${
              isPlural ? 's' : ''
            } on the ${this.getOrdinal(Number(this.dayOfMonth))} of the month`;
          }
          return '';
        }
        case 'Yearly': {
          if (this.repeatByCode === 'Day of the Month') {
            return `Repeat every year on ${this.getOrdinal(
              Number(this.dayOfMonth)
            )} of ${this.monthOfYear}`;
          }
          if (this.repeatByCode === 'Day of the Week and Month') {
            return `Repeat every year on ${this.repeatOn} ${this.dayOfWeek} of ${this.monthOfYear}`;
          }
          return '';
        }
        default: {
          return '';
        }
      }
    }

    return '';
  }
}
